import { DynamicContent } from "components/information-lister-pages/DynamicContent";
import { ResponsiveBlock } from "components/ResponsiveBlock";
import { DEFAULT_IMAGE_URL } from "config/defaults";
import React from "react";
import { useMediaContext } from "lib/media-query";
import { Hero } from "./elements/Hero";
import { HeroSubtitle } from "./elements/HeroSubtitle";
import { HeroTitle } from "./elements/HeroTitle";

export const InformationContent = ({ content = {}, results }) => {
    const { heroTitle, heroImage, heroImageSmall, heroTagline } = content;

    const mediaContext = useMediaContext();
    const isMobilePhone = mediaContext.isMobile || mediaContext.isMobilePlus;

    return (
        <DynamicContent content={content} results={results}>
            <ResponsiveBlock>
                <Hero
                    image={
                        (isMobilePhone
                            ? heroImageSmall?.fields?.file?.url
                            : heroImage?.fields?.file?.url) || DEFAULT_IMAGE_URL
                    }
                    {...(isMobilePhone && { height: "17.75rem" })}
                >
                    <ResponsiveBlock>
                        {!!heroTitle && <HeroTitle size="xl">{heroTitle}</HeroTitle>}
                        {!!heroTagline && <HeroSubtitle>{heroTagline}</HeroSubtitle>}
                    </ResponsiveBlock>
                </Hero>
            </ResponsiveBlock>
        </DynamicContent>
    );
};

InformationContent.displayName = "InformationContent";

InformationContent.getContextProps = async (content) => {
    return DynamicContent.getContextProps(content);
};
